export default __webpack_public_path__ + "static/media/Two.e56e8e30.svg";